import { Card, CardBody, Col, Row } from "reactstrap";
import { AnimatedRibbonsTitle } from "../../../../Constants/Constants";
import { AnimatedRibbonsSubTitle } from "../../../../Data/BonusUi/Ribbons";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import AnimatedRibbonsCard from "./AnimatedRibbonsCard";
import RibbonsCard from "./RibbonsCard";

const AnimatedRibbons = () => {
  return (
    <Row>
      <Col sm="12" xl="12">
        <Card>
          <CommonCardHeader title={AnimatedRibbonsTitle} span={AnimatedRibbonsSubTitle} />
          <CardBody>
            <Row className="g-3">
             <AnimatedRibbonsCard />
             <RibbonsCard />
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default AnimatedRibbons;
